<script>
import StatSitesGraph from '../StatSitesGraph/StatSitesGraph.vue';
import DropdownMenu from '../DropdownMenu/DropdownMenu.vue';
import {mapState, mapActions} from 'vuex';
import { map } from 'lodash-es';
import Fake from '../Fake/Fake.vue';

export default {
    components: {
        StatSitesGraph,
        DropdownMenu,
        Fake
    },
    data () {
        return {
            chartHeight: 400
        }
    },
    computed: {
        ...mapState({
            sites: state => state.stats.sites,
            loading: state => state.stats.statSites.loading,
            error: state => state.stats.statSites.error,
            noContent: state => state.stats.statSites.noContent,
            period: state => state.stats.period,
            predicate: state => state.stats.statSites.predicate,
            predicates: state => state.stats.statSites.predicates
        }),
        chartData () {
            const _chartData = {
                label: 'Sales'
            };

            _chartData.data = map(this.filteredSites, (site) => {
                return site[this.predicate];
            });

            return [_chartData];
        },
        labels () {
            return map(this.filteredSites, (site) => {
                return site.name;
            });
        },
        filteredSites () {

            let _sites = [...this.sites];

            _sites.sort((a, b) => {
                return b[this.predicate] - a[this.predicate];
            });

            return _sites.slice(0, 10);
        },
        options () {
            return {
                responsive: true,
                maintainAspectRatio: false,
                legend: {
                    display: false
                },
                scales: {
                    xAxes: [{
                        ticks: {
                            beginAtZero: true,
                            callback: (value) => {
                                if (value % 1 === 0) {
                                    return this.predicate === 'revenue' ? `€ ${this.$shortNumber(value)}` : value;
                                }
                            }
                        }
                    }]
                },
                tooltips: {
                    enabled: true
                }
            }
        },
    },
    methods: {
        ...mapActions({
            setFilter: 'stats/setFilter'
        }),
    },
}
</script>

<template>
    <div class="stat-sites">
        <transition name="fade" mode="out-in">
            <div v-if="noContent || error" class="stat-sites__no-content">
                <div class="stat-sites__no-content-icon">
                    <i class="fa fa-fw fa-exclamation-triangle"/>
                </div>
                <div class="stat-sites__no-content-message">
                    <span v-if="noContent">{{ $t(`statSites.noContent.missing`) }}</span>
                    <span v-if="error">{{ $t(`statSites.noContent.error`) }}</span>
                </div>
            </div>
            <div v-if="sites && !loading" :key="'content'" class="stat-sites__content">
                <div class="stat-sites__header">
                    <div v-if="sites.length > 10" class="stat-sites__heading">
                        {{ $t(`statSites.predicate.${predicate}`) }}: {{ $t(`statSites.alternativeHeading`) }}
                    </div>
                    <div v-else class="stat-sites__heading">
                        {{ $t(`statSites.predicate.${predicate}`) }}: {{ $t(`statSites.heading`) }}
                    </div>
                    <div class="stat-sites__option">
                        <dropdown-menu :label="$t('statSites.dropdown.label')"
                                       :value="predicate"
                                       :items="predicates"
                                       :translation-prefix="'statSites.predicate'"
                                       @input="setFilter({sites: $event})"/>
                    </div>
                </div>
                <div class="stat-sites__body">
                    <stat-sites-graph
                        :chart-data="chartData"
                        :labels="labels"
                        :height="chartHeight"
                        :options="options"
                        :filtered-sites="filteredSites"/>
                </div>
            </div>
            <fake v-if="loading"
                  :header-rows="1"
                  :body-rows="10"
                  :body-cells="4"
                  :key="'fake'"/>
        </transition>
    </div>
</template>



// WEBPACK FOOTER //
// src/components/StatSites/StatSites.vue